'use client';
import { useContext, createContext } from 'react';
import client from '@s7/http';
import { InMemoryCache } from '../cache-providers/in-memory-storage.js';

var queryDefaultContext = [
    client,
    InMemoryCache
];
var QueryContext = /*#__PURE__*/ createContext(queryDefaultContext);
function useQueryContext(overrides) {
    var _useContext = useContext(QueryContext), _$client = _useContext[0], cache = _useContext[1];
    var _overrides_client, _overrides_cache;
    return [
        (_overrides_client = overrides == null ? void 0 : overrides.client) != null ? _overrides_client : _$client,
        (_overrides_cache = overrides == null ? void 0 : overrides.cache) != null ? _overrides_cache : cache
    ];
}

export { QueryContext, queryDefaultContext, useQueryContext };
